export const stripOuterPTag = (html: string) => html.replace(/^<p>([\s\S]*)<\/p>$/i, "$1").trim();